import { i18n } from "discourse-i18n";
import FormFieldBase from "../base";

export default class CustomFieldBase extends FormFieldBase {
  displayDescriptionByDefault = true;

  get shouldDisplayTitle() {
    return super.shouldDisplayTitle && this.args.field.displayName;
  }

  get title() {
    if (!this.shouldDisplayTitle) {
      return null;
    }

    return (
      this.args.title ||
      i18n(this.titleI18n, {
        translatedFallback: this.args.field.displayName,
      })
    );
  }

  get shouldDisplayDescription() {
    return super.shouldDisplayDescription && this.args.field.description;
  }

  get description() {
    if (!this.shouldDisplayDescription) {
      return null;
    }

    return (
      this.args.description ||
      i18n(this.descriptionI18n, {
        translatedFallback: this.args.field.description,
      })
    );
  }
}
